<template>
	<a :href="action.link" class="info-action">
		<div class="info-action-column">
			<template v-if="action.icon">
				<v-icon color="newwarning" size="30">{{ action.icon }}</v-icon>
			</template>
			<template v-else>
				<img :src="action.urlImage" alt="">
			</template>
		</div>
		<div class="info-action-column">
			<p class="info-action-title">
				{{ action.title }}
			</p>
			<span class="info-action-message">
				{{ action.message }}
			</span>
		</div>
	</a>
</template>

<script>
	export default {
		name: 'info-action',
		props: {
			action: {
				default: () => {},
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.info-action {
		align-items: center;
		color: color(newwarning);
		display: flex;
		text-decoration: none;
		width: 45%;

		&:first-child,
		&:nth-child(2) {
			margin-bottom: 9px;

			@media (min-width: 936px) {
				margin-bottom: 0px;
			}
		}

		@media (min-width: 936px) {
			width: auto;
		}

		&-column {
			&:first-child {
				margin-right: 9px;

				@media (min-width: 936px) {
					margin-right: 19px;
				}
			}
		}

		&-title {
			font-size: size(medium13);
			font-weight: weight(bold);
			line-height: normal;
			margin-bottom: 3px;
		}

		&-message {
			display: inline-block;
			font-size: size(small);
			font-weight: weight(regular);
			line-height: normal;
			max-width: 102px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/info-action.vue